<div class="mb-2 flex items-center justify-between">
  <h1 class="main-title">Gestión de turnos > Informe Jefe de Turno > Previsualización</h1>
  <a class="button button-outlined-primary button-sm" [routerLink]="['/shift-report']">
    <i class="fa-solid fa-chevron-left" alt=""></i>
    Volver
  </a>
</div>

<div class="box pb-16">
  <h2 class="main-subtitle">Seguridad / Medio Ambiente / Calidad</h2>
  <app-table
    class="table-news table-switch"
    [columns]="seguridadColumns"
    [data]="flattenedData['seguridad']"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(visation)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button
          (click)="deleteUpdateRecord(visation.id)"
          title="Eliminar"
        >
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2 class="main-subtitle">Personal (Ausentismo, Licencias Médicas)</h2>
  <app-table
    class="table-news table-switch"
    [columns]="personalColumns"
    [data]="flattenedData['personal']"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(visation)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button
          (click)="deleteUpdateRecord(visation.id)"
          title="Eliminar"
        >
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<div class="box pb-16">
  <h2 class="main-subtitle mb-3">Novedades por área</h2>

  <h3>Proceso General</h3>
  <app-table
    class="table-news table-switch"
    [columns]="generalTableColumns"
    [data]="flattenedData['novedades']"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button (click)="openCloneConfirmation(visation)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button
          (click)="deleteUpdateRecord(visation.id)"
          title="Eliminar"
        >
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h3 class="mt-10">Aviso de averías solicitado</h3>
  <app-table
    class="table-news table-switch"
    [columns]="reportedBreakdownNoticeTableColumns"
    [data]="flattenedData['aviso_averias']"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button (click)="openCloneConfirmation(visation)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button
          (click)="deleteUpdateRecord(visation.id)"
          title="Eliminar"
        >
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h3 class="mt-10">Orden de Trabajo</h3>
  <div style="width: 100%; overflow: auto">
    <app-table
      class="table-news table-switch"
      [columns]="workOrderTableColumns"
      [data]="flattenedData['o_t_ejecutadas']"
      (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)" title="Ver">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
          <button (click)="openCloneConfirmation(visation)" title="Clonar">
            <img src="assets/icons/copy-icon.svg" alt="" />
          </button>
          <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
          </button>
          <button
            (click)="deleteUpdateRecord(visation.id)"
            title="Eliminar"
          >
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </div>

  <!-- Fuera de servicios -->
  <h3 class="mt-10">Fuera de servicios</h3>
  <app-table
    class="table-news table-switch"
    [columns]="outOfServiceTableColumns"
    [data]="flattenedData['fuera_servicio']"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button (click)="openCloneConfirmation(visation)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button
          (click)="deleteUpdateRecord(visation.id)"
          title="Eliminar"
        >
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<app-confirm-popup
  *ngIf="showClonePopup"
  [message]="'¿Está seguro que deseas copiar esta novedad?'"
  (onConfirm)="confirmClone()"
  (onCancel)="closeClonePopup()"
></app-confirm-popup>
